import { useMutation, useQueryClient } from '@tanstack/react-query';

import { engagementResourcesService } from '../services';

import { engagementResourcesKeys } from './useEngagementResources';

export function useAssignResourceLocations(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (locationIds: string[]) =>
      engagementResourcesService.assignLocations(id, locationIds),
    // onSettled (not onSuccess) so a partial-chunk failure still refreshes
    // the UI to whatever did persist. The service chunks at 100 per request
    // to stay under the BE cap; if chunk N throws, chunks 0..N-1 already
    // landed and the cache needs to reflect that.
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: engagementResourcesKeys.detail(id) });
      // List rows surface a "1 location" pill that hangs off locationIds; if
      // we ever start showing that summary on the grid, the lists query is
      // also stale.
      void qc.invalidateQueries({ queryKey: engagementResourcesKeys.lists() });
    },
  });
}
